// Placeholder to create new thirdparty js file